import type { CSSProperties } from "react";

export const PRODUCT_PHOTO_INDEX: Record<string, number> = {
  sign: 0,
  business: 1,
  rollup: 2,
  stickers: 3,
  event: 4,
  gift: 5,
};

export function HomepageProductPhoto({
  visual,
  alt,
  className = "",
}: {
  visual: string;
  alt: string;
  className?: string;
}) {
  const index = PRODUCT_PHOTO_INDEX[visual.replace("-mockup", "")] ?? 0;
  const style = {
    "--photo-x": `${(index % 3) * 50}%`,
    "--photo-y": `${Math.floor(index / 3) * 100}%`,
  } as CSSProperties;
  return (
    <span
      className={`hp-studio-photo ${className}`}
      style={style}
      role="img"
      aria-label={alt}
    />
  );
}
